import React from 'react';
import PropTypes from 'prop-types';
import ConnectToStores from '../../../Utilities/Decorators/ConnectToStoresDecorator';
import AutoScopeStyles from '../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import CsvImportActions from '../Actions/CsvImportActions';
import CsvImportStore from '../Stores/CsvImportStore';
import SelectFileView from './SelectFileView.jsx';
import ValidationFailedView from './ValidationFailedView.jsx';
import ImportInProgressView from './ImportInProgressView.jsx';
import ImportCompletedView from './ImportCompletedView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../../Utilities/Decorators/ApplyDecorators';

class CsvImportPageView extends React.Component {
    constructor() {
        super();
        this.state = { }
    }

    static getStores() {
        return [CsvImportStore];
    }

    static getPropsFromStores() {
        const store = CsvImportStore.getState();
        return {
            file: store.file,
            fileName: store.fileName,
            importInProgress: store.importInProgress,
            validationErrors: store.validationErrors,
            importSucceeded: store.importSucceeded
        };
    }

    componentWillUnmount() {
        CsvImportActions.cancelImport();
    }

    render() {
        return (
            <div>
                <SelectFileView
                    file={ this.props.file }
                    onUploadRequested={ this.onImportFileRequested }
                    onFileSelected={ this.onFileSelected }
                    nameOfObjectToImport={ this.props.nameOfObjectToImport }
                    exportUrl={ this.props.exportUrl }
                    exportPageName={ this.props.exportPageName }
                    sampleCsvFile={ this.props.sampleCsvFile }
                    helpUrl={ this.props.helpUrl }
                    isTemplateFileDownloading={ this.props. isTemplateFileDownloading }
                />
                { this.props.importSucceeded && <ImportCompletedView nameOfObjectToImport={ this.props.nameOfObjectToImport } postImportViewCaption={ this.props.postImportViewCaption } viewUrl={ this.props.viewUrl } notesOnCompletion={ this.props.notesOnCompletion } fileName={ this.props.fileName } /> }
                { this.props.importInProgress && <ImportInProgressView /> }
                { this.props.validationErrors.length > 0 && <ValidationFailedView nameOfObjectToImport={ this.props.nameOfObjectToImport } validationErrors={ this.props.validationErrors } fileName={ this.props.fileName } /> }
            </div>
        );
    }

    onImportFileRequested = () => {
        CsvImportActions.submitCsvImportFile(this.props.file, this.props.apiFunctionName);
    }

    onFileSelected = (file) => {
        CsvImportActions.fileSelected(file);
    }

    static propTypes = {
        apiFunctionName: PropTypes.string.isRequired,
        nameOfObjectToImport: PropTypes.string.isRequired,
        exportUrl: PropTypes.string,
        exportPageName: PropTypes.string,
        sampleCsvFile: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
        helpUrl: PropTypes.string.isRequired,
        notesOnCompletion: PropTypes.node.isRequired,
        viewUrl: PropTypes.string.isRequired,
        isTemplateFileDownloading: PropTypes.bool
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores, AutoScopeStyles);

export default withDecorators(CsvImportPageView);
